import React from "react";
import {
  Box,
  Header,
  OldButton as Button,
  Typography,
  Stack,
} from "digiwash-components";
import { Image, TouchableOpacity } from "react-native";
import * as Updates from "expo-updates";

import { APP_VERSION, BUILD_NUMBER } from "../../configs/constants-config";

import ButtonHeaderBack from "../ButtonHeaderBack";
import CustomIcon from "../CustomIcon";

function crossPlatformLogoImport() {
  let asset = require(`../../resources/logo.png`);
  return asset?.default || asset;
}

let logo = crossPlatformLogoImport();

interface PropTypes {
  onLogo?: () => void;
  onBack?: () => void;
  noBack?: boolean;
  children?: React.ReactNode;
  title?: string;
  action?: () => void;
}

function AppHeader(props: PropTypes) {
  let actionComponent = undefined;
  let secondaryActionComponent = undefined;
  if (props.action) {
    secondaryActionComponent = (
      <TouchableOpacity onPress={props.action}>
        <Stack distribution="center" style={{ width: 36, height: 30 }}>
          <CustomIcon icon="more" width={24} height={10} />
        </Stack>
      </TouchableOpacity>
    );
  }

  if (props.onBack) {
    actionComponent = <ButtonHeaderBack onBackClick={props.onBack} />;
  }

  if (props.noBack) {
    actionComponent = null;
  }

  return (
    <Header
      logoRenderer={
        <>
          {props.title ? (
            <>
              <Stack distribution="center">
                <Typography ff="mainBold" color="primary.light950" fs="l">
                  {props.title}
                </Typography>
              </Stack>
            </>
          ) : (
            <Button
              onPress={props.onLogo}
              onLongPress={() => {
                let version = `${APP_VERSION} (build ${BUILD_NUMBER})`;
                alert(version);
                Updates.reloadAsync();
              }}
            >
              <Box distribution="center">
                <Image source={logo} style={{ width: 98, height: 22 }} />
              </Box>
            </Button>
          )}
        </>
      }
      actionRenderer={actionComponent}
      secondaryActionRenderer={secondaryActionComponent}
      bottomRenderer={props.children}
    />
  );
}

export default AppHeader;
